import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, Toaster } from '@share/utils';
import { axiosInstanceB2B } from '@share/utils';
import { IAccount, IAccountPreference } from '@share/common-types';

export interface IAccountSettingState {
  preferences: IAccountPreference[];
  loading: boolean;
}

const initialState: IAccountSettingState = {
  preferences: [],
  loading: false
};

const accountSettingSlice = createSlice({
  name: 'accountSetting',
  initialState,
  reducers: {
    setLoading: (state: IAccountSettingState, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setPreferences: (state: IAccountSettingState, { payload }: PayloadAction<IAccountPreference[]>) => {
      state.preferences = payload;
    }
  },
});

export const accountSettingActions = accountSettingSlice.actions;
export const accountSettingReducer = accountSettingSlice.reducer;

export const handlePreferences = (account: IAccount, preferences: IAccountPreference[], formData: FormData): AppThunk => {
  return async (dispatch) => {
    dispatch(accountSettingActions.setLoading(true));

    try {
      formData.append("request", JSON.stringify({ accountId: account?.id, accountName: account?.name, preferences: preferences }));
      const response = await axiosInstanceB2B.post(`/identity/account/preferences`, formData);
      if (response.data.success) {
        Toaster.success('Changes applied successfully.');
      }
      else {
        Toaster.error('An error occurred. Please try again.');
      }
      dispatch(accountSettingActions.setLoading(false));
    } catch (error: any) {
      Toaster.error('An error occurred. Please try again.');
      dispatch(accountSettingActions.setLoading(false));
    }
  };
};